@if (!hasAuskunftsperre || (hasAuskunftsperre && hasPermissionAuskunft) || (hasAuskunftsperre && isEigentuemer)) {
  <ng-template [ngTemplateOutlet]="auskunftsperreIcon"></ng-template>
  <cap-link
    [enableNavigation]="enableNavigation"
    [queryParams]="{ id: itemMasterId?.id, versionId: itemVersionId?.id }"
    [target]="navTargets.NAV_PERSON_GB">
    <ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
  </cap-link>
} @else {
  <span style="font-style: italic">{{ "stammperson-auskunftsperre" | translate }}</span>
}
<ng-template #typ00>
  @if (!item.gemeinschaftArt && !item.name) {
    {{ "UNBEKANNT" | translate }}
  }
  @if (!!item.gemeinschaftArt) {
    {{ item.gemeinschaftArt | translate }}
  }
  <ng-template [ngTemplateOutlet]="nameVorname"></ng-template>
  @if (item.ledigname) {
    <span> ({{ item.ledigname }})</span>
  }
  <ng-template [ngTemplateOutlet]="geburtsdatumSitzUid"></ng-template>
</ng-template>

<ng-template #typ01>
  <ng-template [ngTemplateOutlet]="nameVorname"></ng-template>
  <ng-template [ngTemplateOutlet]="geburtsdatumSitzUid"></ng-template>
</ng-template>

<ng-template #nameVorname>
  {{ item.name }}
  @if (item.vorname) {
    <span> {{ item.vorname }}</span>
  }
</ng-template>

<ng-template #geburtsdatumSitzUid>
  @if (isNotEmpty(item.geburtsdatum)) {
    <span>, {{ item.geburtsdatum | dayMonthYearDate }}</span>
  }
  @if (item.sitz) {
    <span>, {{ item.sitz }}</span>
  }
  @if (item.unternehmensId) {
    <span> ({{ "UID" | translate }}: {{ item.unternehmensId | formatUid }})</span>
  }
</ng-template>

<ng-template #auskunftsperreIcon>
  @if ((hasAuskunftsperre && hasPermissionAuskunft) || (hasAuskunftsperre && isEigentuemer)) {
    <div class="float-start me-2">
      <span
        [ngbTooltip]="'stammperson-auskunftsperre-mitBerechtigung' | translate"
        [placement]="'top'"
        class="ms-1 fas fa-exclamation-triangle text-warning"></span>
    </div>
  }
</ng-template>
